export default "__VITE_ASSET__ClZ1Spxe__"